export default __webpack_public_path__ + "static/media/cara-btn-right.f39cc312.svg";